import React, { FC, useEffect, useMemo } from 'react';

import {
  IAdminCompleteContract,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import { Box, Grid, Stack } from '@mui/material';
import { stub } from '@pharmaplan/common/helpers/utils';
import { useFormik } from 'formik';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import useViewAllLongTermContracts from '../../../../hooks/ViewAllLongTermContracts/useViewAllLongTermContracts';
import styles from './styles';
import LongContractCard from '../../../common/LongContractCard';
import strings from '../../../../localization';
import CustomButton from '../../../common/CustomButton';
import genericClasses from '../../../../theme/GenericClasses';
import { resetDialog } from '../../../../reducers/dialogReducer';
import ShiftsDistributionItem from '../../../SelfService/PharmacistProfile/LongShiftsDistribution/ShiftsDistributionItem';
import { Constants } from '../../../../helpers/Constants';
import PromoAppliedLabel from './PromoAppliedLabel';

interface IViewPharmacyShiftDetails {
  longTermContractId: string;
  professionalId: string;
}

const ViewPharmacyShiftDetails: FC<IViewPharmacyShiftDetails> = ({
  longTermContractId,
  professionalId,
}) => {
  const dispatch = useAppDispatch();
  const { contract, getAPI, longTermContract, successAction } = useViewAllLongTermContracts({
    longTermContractId,
    professionalId,
    type: PharmacistLegendVariant.booked,
  });

  useEffect(() => {
    getAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    pharmacyWeekDayHourlyRate,
    pharmacyWeekendHourlyRate,
    promoHourlyRate,
  } = (contract as IAdminCompleteContract) ?? {};
  const { allowanceNotes } = longTermContract ?? {};

  const formik = useFormik({
    initialValues: {
      allowanceNotes,
      weekDayPaidHourlyRate: pharmacyWeekDayHourlyRate,
      weekendPaidHourlyRate: pharmacyWeekendHourlyRate,
      promoHourlyRate,
    },
    enableReinitialize: true,
    onSubmit: stub,
  });

  const handleClose = () => {
    dispatch(resetDialog());
  };

  const formattedContract = {
    ...contract,
    startDate: contract.contractStartDate,
    longTermShiftContract: longTermContract,
    endDate: contract.contractEndDate,
  };

  const totalPromoBookings = useMemo(
    () =>
      contract.data.filter((item) =>
        item.isPromoBooking).length,
    [contract.data],
  );

  return (
    <Box sx={styles.container}>
      <Box sx={styles.subContainer}>
        <Grid container columnSpacing="30px">
          <Grid md={5} xs={12} item>
            <Stack>
              <Box sx={{ mb: '24px' }}>
                <LongContractCard
                  successAction={successAction}
                  event={formattedContract as any}
                  isBooked
                  showPromo={!!promoHourlyRate}
                  formik={formik}
                />
              </Box>
            </Stack>
          </Grid>
          <Grid md={7} xs={12} item>
            {!!totalPromoBookings && <PromoAppliedLabel label={strings.promoRateAppliedFormat2} promoHourlyRate={promoHourlyRate ?? 0} totalPromoBookings={totalPromoBookings} />}
            <Box sx={styles.grid}>
              <ShiftsDistributionItem totalShifts={contract?.data} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={[styles.buttonContainer, genericClasses.flex]}>
        <CustomButton
          label={strings.close}
          onClick={handleClose}
          variant={Constants.variant.contained}
          customClass={styles.closeButton}
        />
      </Box>
    </Box>
  );
};

export default ViewPharmacyShiftDetails;
